import * as React from "react";

export type Props = {
	src: string
	async?: boolean
	defer?: boolean
	callback?: Function
}

export default class Script extends React.Component<Props> {
	private getScript = ():any => document.querySelector("script[src='" + this.props.src + "']") as HTMLElement;

	componentDidMount() {
		let exists = this.getScript();
		if(!exists) {
			let script = document.createElement("script");

			if(this.props.callback) {
				script.onload = () => this.props.callback();
			}

			document.body.appendChild(script);

			script.src = this.props.src;
			script.async = this.props.async;
			script.defer = this.props.defer;
			script.dataset.users = "1";
		} else if(this.props.callback) {
			let users = Number(exists.dataset.users);
			exists.dataset.users = String(users+1);
			this.props.callback();
		}
	}

	componentWillUnmount() {
		let exists = this.getScript();
		if(exists.dataset.users == "1") {
			exists.remove();
		} else {
			let users = Number(exists.dataset.users);
			exists.dataset.users = String(users-1);
		}
	}

	render = () => <></>
}